import script from "./PaymentStatusPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentStatusPanel.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentStatusPanel.vue?vue&type=style&index=0&id=a35521a6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a35521a6"]])

export default __exports__